import { gql } from "@apollo/client";

export const GET_METODOS_CONFORMIDADES = gql`
    query GetMetodosConformidades {
        metodosEnvio {
            idMetodoEnvio
            descripcion
        }
    }
`;

export const adaptMetodosConformidadesArray = (array) => {
    return array?.map(item => ({
        id: item.idMetodoEnvio,
        displayName: item.descripcion
    }));
}